module.exports = __webpack_public_path__ + "media/images/countrysquared/ve-b93b9a8b5629ddf47be484ed8edc7db7.svg";